import type { Style } from './types';

import { alpha } from '@mui/material/styles';
import { yellow } from '@mui/material/colors';

export const getButtonVariant = (style?: Style | null) => {
  if (!style?.variant) return 'contained';
  switch (style.variant) {
    case 'primary':
      return 'contained';
    case 'secondary':
      return 'soft';
    case 'tertiary':
      return 'text';
    case 'danger':
      return 'contained';
    case 'ghost':
      return 'text';
    default:
      return 'contained';
  }
};

export const getButtonColor = (style?: Style | null) => {
  if (!style?.variant) return 'primary';
  switch (style.variant) {
    case 'primary':
      return 'primary';
    case 'secondary':
      return 'primary';
    case 'tertiary':
      return 'primary';
    case 'danger':
      return 'error';
    case 'ghost':
      return 'inherit';
    default:
      return 'primary';
  }
};

export const getTextVariant = (style?: Style | null) => {
  if (!style?.emphasis) return 'body1';

  switch (style.emphasis) {
    case 'low':
      return 'body2';
    case 'medium':
      return 'body1';
    case 'high':
      return 'h6';
    default:
      return 'body1';
  }
};

const MARKER = alpha(yellow[500], 0.3);

/** A marker pen over a page: yellow, 70% see-through, no edge. Multiply keeps the words under it black. */
export const highlighterSx = { bgcolor: MARKER, mixBlendMode: 'multiply' } as const;

/** The same marker over a photo, where multiply would vanish on dark colours. */
export const photoHighlighterSx = { bgcolor: MARKER } as const;
